export function pushEventToDataLayer(event: string, data: Record<string, any>) {
  if (!window || !window.dataLayer) return;

  window.dataLayer.push({
    event,
    ...data,
  });
}
